import { Button } from "@mui/material";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "components/modal/modal";
import { AppAction, AppContext } from "helpers/context";
import {
  parseGeoJsonFile,
  ParseGeoJsonResult,
  ParseGeoJsonError
} from "./parseGeoJsonFile";
import ImportModalContent from "./import-modal-content";
import styles from "./import-modal.module.scss";

interface ImportModalProps {
  open: boolean;
  onClose: () => void;
  onParsedSuccess: (data: ParseGeoJsonResult) => void;
  // onParsedSuccess: (data: Shape) => void;
}

const ImportModal: React.FC<ImportModalProps> = ({
  open,
  onClose,
  onParsedSuccess
}) => {
  const [t] = useTranslation();
  const [, dispatch] = useContext(AppContext);
  const [loading, setLoading] = useState(false);

  const handleChangeUploadFile = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLoading(true);

    const file = event.target.files?.[0];
    if (!file) {
      setLoading(false);
      return;
    }

    parseGeoJsonFile(
      file,
      (data: ParseGeoJsonResult) => {
        onParsedSuccess(data);
        setLoading(false);
      },
      (error: ParseGeoJsonError) => {
        dispatch({
          type: AppAction.addSnackBarParams,
          payload: {
            titleIcon: "error",
            titleIconColor: "red",
            title: error.title,
            message: error.message
          }
        });
        setLoading(false);
        onClose();
      }
    );
  };

  return (
    <Modal opened={open} onClose={onClose} header={t("myShapes.modal.title")}>
      <ImportModalContent
        loading={loading}
        onChangeFile={handleChangeUploadFile}
      />
      <div className={styles.buttons}>
        <Button color="success" onClick={onClose}>
          {t("buttons.cancel")}
        </Button>
      </div>
    </Modal>
  );
};

export default ImportModal;
